import { connect } from 'react-redux';
import NewAlarmConfigModal from './NewAlarmConfigModal';
import { getData } from '../../../actions/utils';
import commonActions from '../../../actions/common';
import usersSchema from '../../../normalizr-schemas/usersSchema';
import machinesSchema from '../../../normalizr-schemas/machinesSchema';
import { submitAlarmConfig } from '../../../actions/alarmsConfig';

const alarmsConfigActions = commonActions('alarmsConfig');

const mapStateToProps = ({ users, machines, alarmsConfig }) => ({
  users,
  machines,
  alarmsConfig,
});

const mapDispatchToProps = dispatch => ({
  submitAlarmConfig: newConfig => dispatch(submitAlarmConfig(newConfig)),
  closeNewAlarmConfigModal: () => dispatch(alarmsConfigActions.closeNewModal()),
  closeEditAlarmsConfigModal: id => dispatch(alarmsConfigActions.closeEditModal(id)),
  getOrganisationUsers: () => dispatch(getData('users', 'users', usersSchema, false)),
  // getOrganisationMachines: () => dispatch(getOrganisationMachines()),
  getOrganisationMachines: () => dispatch(getData('machines', 'machines', machinesSchema, false)),
});

const NewAlarmConfigModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewAlarmConfigModal);

export default NewAlarmConfigModalContainer;



// WEBPACK FOOTER //
// ./src/components/Settings/alarms/NewAlarmConfigModalContainer.js